export enum MonitoringItemImageStatus {
    MONITORING_DONE = "Monitoring Done",
    PENDING_MONITORING = "Pending Monitoring"
}
